import React from 'react';
import { Checkbox } from '@attentive-platform/stem-ui';

export const ScopeItem = ({ scope, isSelected, onToggle, onClick, disabled }) => (
  <div className={`rosetta-scope-item ${isSelected ? 'selected' : ''}`} onClick={onClick}>
    <Checkbox checked={isSelected} onChange={onToggle} disabled={disabled} size='small' />
    <div className='rosetta-scope-name'>{scope.scope_name}</div>
    {scope.is_default_selected && <div className='rosetta-included-tag'>INCLUDED</div>}
  </div>
);

export const ScopeCategory = ({ title, scopes, tradeId, selectedScopes, onScopeItemClick, onToggleScope }) => (
  <div className='rosetta-scope-category'>
    <h4 className='rosetta-scope-category-title'>{title}</h4>
    {scopes.map(scope => (
      <ScopeItem
        key={scope.scope_id}
        scope={scope}
        isSelected={selectedScopes?.has(scope.scope_id) || false}
        onToggle={() => !scope.is_default_selected && onToggleScope(tradeId, scope.scope_id)}
        onClick={() => onScopeItemClick(scope)}
        disabled={scope.is_default_selected}
      />
    ))}
  </div>
);

export const CustomRequirement = ({ trade, customScope, onChange }) => (
  <div className='rosetta-custom-scope-item mt-2'>
    <label htmlFor={`custom-${trade.trade_id}`}>{trade.trade_name} - Additional Requirements</label>
    <textarea
      id={`custom-${trade.trade_id}`}
      placeholder='Enter any specific requirements, exclusions, or clarifications...'
      value={customScope}
      onChange={onChange}
    />
  </div>
);
